import {Platform, StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {alto, cloudLightest, grey80, onyx, white} from '/theme/color/on.color';
import {pineDarker} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  base: {
    backgroundColor: cloudLightest,
    alignItems: 'flex-end',
  },
  text: {
    marginLeft: 8,
    fontSize: 14,
    color: onyx,
  },
  teamOrgText: {
    flexShrink: 1,
    overflow: 'hidden',
    maxWidth: 'auto',
  },
  modal: {
    margin: 0,
    justifyContent: 'flex-start',
    alignItems: 'flex-end',
    backgroundColor: grey80,
    width: '100%',
    height: '100%',
  },
  modalView: {
    width: 400,
    height: '100%',
    backgroundColor: white,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    paddingBottom: 20,
    paddingLeft: 20,
    shadowColor: '#000',
    shadowOffset: {
      width: -2,
      height: 0,
    },
    shadowOpacity: 0.25,
    shadowRadius: 10,
    elevation: 5,
  },
  modalHeader: {
    flexDirection: 'row',
    padding: 10,
    marginTop: 10,
  },
  headerText: {
    fontSize: 16,
    marginLeft: 10,
  },
  radioButtonsContainer: {
    flexDirection: 'column',
    marginHorizontal: 20,
  },
  sortContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    borderWidth: 1,
    paddingVertical: 10,
    paddingHorizontal: 14,
    marginLeft: indent * 0.4,
    borderRadius: indent * 0.4,
    borderColor: alto,
    backgroundColor: white,
  },
  teamOrgsortContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    borderWidth: 1,
    height: 38,
    paddingVertical: indent * 0.2,
    paddingHorizontal: indent * 0.8,
    borderRadius: indent * 0.4,
    borderColor: alto,
    backgroundColor: white,
    // maxWidth: 300,
    minWidth: 140,
    marginLeft: 12,
  },
  fontSize20: {
    fontSize: 20,
    color: pineDarker,
  },
  disabled: {
    opacity: 0.5,
  },
  closeIcon: {
    ...(Platform.OS === 'web' && {cursor: 'pointer'}),
  },
});
